export default {
  header: 'Recent movements',
  empty: 'No movements yet.',
  date: 'Date',
  direction: 'Direction',
  product: 'Product',
  bottleSize: 'Bottle size',
  amount: 'Amount',
  batchId: 'BatchId',
  uniqueId: 'Unique ID',
  note: 'Note',
  sold: 'SOLD',
  out: 'OUT',
  in: 'IN',
};
